<div *ngIf="unreadMessageCount" class="unread-badge" [class.with-text]="!hideText" [class.without-text]="hideText">
  {{ hideText ? '' : unreadMessageCount }}
</div>
